import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-filter-category',
  templateUrl: './filter-category.component.html',
  styleUrls: ['./filter-category.component.scss'],
  // changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FilterCategoryComponent implements OnInit {
  @Input() title: string;
  @Input() setOpen: boolean;
  @Input() totalSelected: number;

  isOpen = false;

  constructor() {}

  ngOnInit(): void {
    this.isOpen = this.setOpen;
  }

  log() {
    this.isOpen = !this.isOpen;
  }
}
